import BigNumber from 'bignumber.js'
import React, {useState,useEffect,useCallback} from 'react'
import Web3 from 'web3'
import styled from 'styled-components'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { Button, Heading, Text, Link, Toggle, Flex } from '@pancakeswap-libs/uikit'
import QuestionHelper from 'components/QuestionHelper'
import Input from 'components/Input'
import BalanceInput from 'components/Input/BalanceInput'
import { useERC20 } from 'hooks/useContract'
import { useAllowance } from 'hooks/useAllowance'
import { useTokenApprove } from 'hooks/useApprove'
import { useTokenBalance } from 'hooks/useTokenBalance'
import { getSep20FactoryAddress } from 'utils/addressHelpers'
import useI18n from 'hooks/useI18n'

import { useFeeToken, useCreateSep20TokenLiquidityProvider } from '../hooks/useSep20Factory'


const Row = styled.div`
  margin-top: 25px;
`;

const Label = styled(Text)`
  text-align: left;
  padding-left: 16px;
  margin-bottom: 5px;
`

const Note = styled(Text)`
    text-align: left;
    padding-left: 16px;
`

const Notification = styled(Text)`
  line-height: 18px;
  padding-top: 10px;
`

interface CreateProps {
  onSuccess?: any
}

const Create: React.FC<CreateProps> = ({ onSuccess }) => {
  const TranslateString = useI18n();
    const { account } = useWallet();

    const [name, setName] = useState('')
    const handleNameChange = (e: React.FormEvent<HTMLInputElement>) => {
      setName(e.currentTarget.value); 
    }
    
    const [symbol, setSymbol] = useState('')
    const handleSymbolChange = (e: React.FormEvent<HTMLInputElement>) => {
      setSymbol(e.currentTarget.value);
    }

    const [initialSupply, setInitialSupply] = useState('')
    const handleInitialSupplyChange = (e: React.FormEvent<HTMLInputElement>) => {
      setInitialSupply(e.currentTarget.value);
    }

    // Tax Fee
    const [taxFeeRate, setTaxFeeRate] = useState("0")
    const handleTaxFeeRateChange = (e: React.FormEvent<HTMLInputElement>) => {
        setTaxFeeRate(e.currentTarget.value);
    }

    // Liquidity Fee
    const [liquidityFeeRate, setLiquidityFeeRate] = useState("0")
    const handleLiquidityFeeRateChange = (e: React.FormEvent<HTMLInputElement>) => {
        setLiquidityFeeRate(e.currentTarget.value);
    }

    // Charity Fee
    const [charityFeeRate, setCharityFeeRate] = useState("0")
    const handleCharityFeeRateChange = (e: React.FormEvent<HTMLInputElement>) => {
        setCharityFeeRate(e.currentTarget.value);
    }

    const [charityAddress, setCharityAddress] = useState('')
    const handleCharityAddressChange = (e: React.FormEvent<HTMLInputElement>) => {
      setCharityAddress(e.currentTarget.value); 
    }

    const feeToken:any = useFeeToken();
    const feeTokenString = `${feeToken.creationFee} ${feeToken.symbol}`;
    const feeTokenBalance = useTokenBalance(feeToken.address).div(new BigNumber(10).pow(feeToken.decimals));
    const notEnoughFee = feeTokenBalance.isLessThan(feeToken.creationFee);

    const [requestedApproval, setRequestedApproval] = useState(false)
    const [approved, setApproved] = useState(0)
    const [pendingTx, setPendingTx] = useState(false)

    const tokenContract = useERC20(feeToken.address);
    const allowance = useAllowance(tokenContract, getSep20FactoryAddress(), approved);
    const onApprove = useTokenApprove(tokenContract, getSep20FactoryAddress())
    const allowed = allowance && !allowance.div(new BigNumber(10).pow(feeToken.decimals)).isLessThan(feeToken.creationFee);

    const handleApprove = useCallback(async () => {
        try {
            setRequestedApproval(true)
            const txHash = await onApprove()
            setRequestedApproval(false)
            if (txHash) {
                setApproved(approved+1);
            }
        } catch (e) {
            console.error(e)
        }
    }, [onApprove, approved])

    const onCreate = useCreateSep20TokenLiquidityProvider();
    const handleSubmit = useCallback(async () => {
        try {
          const txHash = await onCreate(name, symbol, new BigNumber(initialSupply), charityAddress, 
            (Number(taxFeeRate)*100).toFixed(), (Number(liquidityFeeRate)*100).toFixed(), (Number(charityFeeRate)*100).toFixed());
          if (txHash) onSuccess();
          return txHash;
        } catch (e) {
          console.error(e)
        }

        return false;
      }, [onCreate, name, symbol, initialSupply, taxFeeRate, liquidityFeeRate, charityAddress, charityFeeRate, onSuccess])

    let invalidString = "";
    if (!name) invalidString = TranslateString(1534,"Invalid Token Name");
    else if (name.length > 40) TranslateString(1535,"Token Name Too Long");
    else if (!symbol) invalidString = TranslateString(1536,"Invalid Token Symbol");
    else if (symbol.length > 10) invalidString = TranslateString(1537,"Token Symbol Too Long");
    else if (!initialSupply || Number.isNaN(Number(initialSupply)) || Number(initialSupply)<0 || new BigNumber(initialSupply).isGreaterThan(1e15) ) invalidString = TranslateString(1539,"Invalid Supply");
    else if (!taxFeeRate || Number.isNaN(Number(taxFeeRate)) || Number(taxFeeRate) < 0) invalidString = TranslateString(1540,"Invalid Yield Fee Rate");
    else if (!liquidityFeeRate || Number.isNaN(Number(liquidityFeeRate)) || Number(liquidityFeeRate) < 0) invalidString = TranslateString(1541,"Invalid Liquidity Fee Rate");
    else if (!charityFeeRate || Number.isNaN(Number(charityFeeRate)) || Number(charityFeeRate) < 0) invalidString = TranslateString(1542,"Invalid Charity Fee Rate");
    else if (Number(taxFeeRate) + Number(charityFeeRate) + Number(liquidityFeeRate) > 25) invalidString = `${TranslateString(1543,"Invalid Total Fee")} (>25%)`;

    const renderButton = () => {
        if (!allowed && !notEnoughFee) {
            return (
                <Button disabled={requestedApproval} onClick={handleApprove}>
                    {requestedApproval?TranslateString(330,"Approving"):TranslateString(316,"Approve")} {feeToken.symbol}
                </Button>
            )
        }
        return (
            <Button disabled={pendingTx || notEnoughFee || !!invalidString} onClick={async () => {
                setPendingTx(true)
                const txHash = await handleSubmit()
                setPendingTx(false)
              }}>
                {notEnoughFee?TranslateString(319,"Insufficient Fee"):(invalidString||TranslateString(320,"Submit"))}
            </Button>
        )
    }
    return (
        <>
            <Row>
              <Label>{TranslateString(410,'Name:')}</Label>
              <Input placeholder={TranslateString(411,'Token Name')} value={name} onChange={handleNameChange} />
            </Row>
            <Row>
              <Label>{TranslateString(412,'Symbol:')}</Label>
              <Input placeholder={TranslateString(415,"Token Symbol")} value={symbol} onChange={handleSymbolChange} />
            </Row>
            <Row>
              <Label>{TranslateString(524,'Total Supply (Max: 1 Quadrillion):')}</Label>
              <Input placeholder={TranslateString(525,'Total Supply')} value={initialSupply} onChange={handleInitialSupplyChange} />
            </Row>
            <Row>
                <Label><Flex alignItems="center" justifyContent="flex-start">
                    <div>{TranslateString(526,'Transaction fee to generate yield (&#37;):').replace(/&#37;/g,"%")}</div>
                    <QuestionHelper text={TranslateString(527, 'The fee rate from every transaction which is distributed to all token holders. It can have up to two decimal places and same to the percentage fields below.')} />
                </Flex></Label>
                <Input placeholder={TranslateString(528,"Yield Fee Rate")} value={taxFeeRate} onChange={handleTaxFeeRateChange} />
            </Row>
            <Row>
                <Label><Flex alignItems="center" justifyContent="flex-start">
                    <div>{TranslateString(529,'Transaction fee to generate liquidity (&#37;):').replace(/&#37;/g,"%")}</div>
                    <QuestionHelper text={TranslateString(1229,'The fee rate from every transaction which is distributed to the liquidity pool.')} />
                </Flex></Label>
                <Input placeholder={TranslateString(537,'Liquidity Fee Rate')} value={liquidityFeeRate} onChange={handleLiquidityFeeRateChange} />
                <Note>{TranslateString(530,'* If this is more than 0, please add some liquidity to the WBCH pair right after the token creation to avoid transaction errors later.')}</Note>
            </Row>
            <Row>
              <Label>{TranslateString(531,'Charity/Marketing address:')}</Label>
              <Input placeholder={TranslateString(534,'Charity/Marketing address')} value={charityAddress} onChange={handleCharityAddressChange} />
            </Row>
            <Row>
              
                <Label><Flex alignItems="center" justifyContent="flex-start">
                  <div>{TranslateString(532,'Charity/Marketing (&#37;):').replace(/&#37;/g,"%")}</div>
                  <QuestionHelper text={TranslateString(1230,'The fee rate from every transaction which is distributed to the charity/marketing address. Only effective with a valid charity/marketing address.')} />
                </Flex></Label>
                <Input placeholder={TranslateString(538,'Charity/Marketing Fee Rate')} value={charityFeeRate} onChange={handleCharityFeeRateChange} />
            </Row>
            <Row>
              <Notification>{TranslateString(315,"Fee")}: {feeTokenString}</Notification>
            </Row>
            <Row>
              {renderButton()}
            </Row>
        </>
    )
}

export default Create
 